import React from "react";
import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import {
  DiJavascript1,
  DiReact,
  DiNodejs,
  DiMongodb,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiRedis,
  SiFirebase,
  SiNextdotjs,
  SiSolidity,
  SiPostgresql,
} from "react-icons/si";
import { TbBrandGolang } from "react-icons/tb";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons" techname="C++">
        <CgCPlusPlus />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="JavaScript">
        <DiJavascript1 />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Golang">
        <TbBrandGolang />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Node.js">
        <DiNodejs />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="React">
        <DiReact />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Solidity">
        <SiSolidity />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="MongoDB">
        <DiMongodb />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Next.js">
        <SiNextdotjs />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Git">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Firebase">
        <SiFirebase />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Redis">
        <SiRedis />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="PostgreSQL">
        <SiPostgresql />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Python">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons" techname="Java">
        <DiJava />
      </Col>
    </Row>
  );
}

export default Techstack;
